import { array, object } from 'yup';

import { createValidator } from '@src/validation';
import { textValidator } from '@src/validation/textValidator';
import { PropertyTypes } from '@stores/settingsStore/constants';

const URL_REG_EXP = /^https?:\/\/[^/\s]+(\.[^/\s]+)?(?:\/[^/\s]+)*$/;

const validationSchema = object().shape({
  properties: array().of(
    object().shape({
      value: textValidator({ fieldName: 'value', required: false })
        .test(
          'value',
          'Некорректный адрес',
          (v, { parent: { type } }) => !(type === PropertyTypes.URL && !!v && !URL_REG_EXP.test(v)),
        )
        .test(
          'value',
          'Число должно быть дробным',
          (v, { parent: { type } }) => !(type === PropertyTypes.DOUBLE && !!v && !/^-?[1-9]\d+\.\d+$/.test(v)),
        )
        .test(
          'value',
          'Число не должно оканчиваться на ноль',
          (v, { parent: { type } }) => !(type === PropertyTypes.DOUBLE && !!v && v?.at(-1) === '0'),
        ),
    }),
  ),
});

export const validate = createValidator(validationSchema);
